import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { onCookieConsentChange, shouldShowCookieConsentBanner } from '@/lib/cookieConsent';
import { trackPhoneClick } from '@/lib/analyticsEvents';
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_E164 } from '@/lib/contactDetails';

/**
 * Collapsed to a circle, expands to reveal the number on hover. Sits above the cookie
 * banner while that is on screen so the two never overlap on narrow viewports.
 */
const FloatingContact = () => {
  const { lang, t } = useLanguage();
  const [consentPending, setConsentPending] = useState(false);

  useEffect(() => {
    setConsentPending(shouldShowCookieConsentBanner());
    return onCookieConsentChange(() => setConsentPending(false));
  }, []);

  return (
    <motion.a
      href={`tel:${CONTACT_PHONE_E164}`}
      onClick={() => trackPhoneClick(lang, 'floating_button')}
      aria-label={`${t('contact.phone.aria')}: ${CONTACT_PHONE_DISPLAY}`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
      className={`group fixed right-4 sm:right-6 z-30 flex h-12 items-center rounded-full border border-border/60 bg-foreground pl-3.5 pr-3.5 text-background shadow-lg backdrop-blur-sm transition-[bottom,opacity] duration-300 hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
        consentPending ? 'bottom-52 sm:bottom-32' : 'bottom-6'
      }`}
    >
      <Phone className="h-5 w-5 shrink-0" strokeWidth={1.75} />
      <span className="max-w-0 overflow-hidden whitespace-nowrap font-body text-sm font-medium opacity-0 transition-all duration-300 group-hover:ml-2.5 group-hover:max-w-[12rem] group-hover:opacity-100">
        {CONTACT_PHONE_DISPLAY}
      </span>
    </motion.a>
  );
};

export default FloatingContact;
